import {ACTIONS} from "@intellectability/platform-common/constants";

let glob = import.meta.glob("../../Pages/**/GoalsReviewsList.svelte");

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        {
            layout: "null",
            path: `?action=${process.env.VITE_PAGE_ACTION}`,
            render: getComponent(glob),
            title: process.env.VITE_PAGE_TITLE
        },
        {
            layout: "null",
            path: `?action=${ACTIONS.PERSON_DETAILS_VIEW}`,
            render: getComponent(glob)
        }
    ]
};

export default routerConfig;

/**
 * Find the component to render based on the name
 * @param {Record<string, () => Promise<unknown>>} glob
 * @returns {import("@intellectability/platform-common/router").LazyComponent}
 */
function getComponent(glob) {
    let key = Object.keys(glob)[0];
    if (key) {
        const loader = glob[key + ""];
        return /** @type {import("@intellectability/platform-common/router").LazyComponent} */ (loader);
    }
    return () => import("../../Pages/Core/Security/Errors/NotFound.svelte");
}